import React, { useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { DataGrid } from "@material-ui/data-grid";
import DashboardTableScroll from "../shared/DashboardTableScroll";
import { navigateWithMobileDashboardScroll } from "../../utils/navigateWithMobileDashboardScroll";

const DataGridWrapper = React.memo(({ title, description, rows, columns, emptyMessage, cardClass, onRowClick, getRowClassName }) => {
  const navigate = useNavigate();
  
  const handleRowClick = useCallback((params) => {
    if (onRowClick) {
      const scrollNavigate = (to, options) =>
        navigateWithMobileDashboardScroll(navigate, to, options);
      onRowClick(params, scrollNavigate);
    }
  }, [onRowClick, navigate]);

  return (
    <section className={cardClass}>
      <style>{`
        .order-row-has-update {
          background-color: #fef2f2 !important;
        }
        .order-row-has-update:hover {
          background-color: #fee2e2 !important;
        }
        .MuiDataGrid-cell {
          overflow: visible !important;
        }
      `}</style>
      <header className="mb-6 flex flex-wrap items-end justify-between gap-3">
        <div>
          <h2 className="text-lg font-semibold text-slate-900">{title}</h2>
          {description && <p className="text-sm text-slate-500">{description}</p>}
        </div>
        {rows.length === 0 && emptyMessage && (
          <span className="text-sm font-medium text-slate-500">{emptyMessage}</span>
        )}
      </header>
      <div className="min-w-0 rounded-2xl border border-slate-200">
        <DashboardTableScroll>
          <div className="min-w-[720px]">
            <DataGrid
              rows={rows}
              columns={columns}
              pageSize={10}
              disableSelectionOnClick
              autoHeight
              onRowClick={handleRowClick}
              getRowClassName={getRowClassName}
            />
          </div>
        </DashboardTableScroll>
      </div>
    </section>
  );
});

DataGridWrapper.displayName = "DataGridWrapper";

export default DataGridWrapper;
